import {
  CheckCircleIcon,
  InformationCircleIcon,
  WarningErrorIcon,
} from "vega-icons";

export enum NoticeType {
  BRAND_NO_ICON = "BRAND_NO_ICON",
  WARNING = "WARNING",
  ERROR = "ERROR",
  SUCCESS = "SUCCESS",
  PENDING = "PENDING",
  BRAND = "BRAND",
  DEFAULT = "DEFAULT",
  SECONDARY_NO_ICON = "SECONDARY_NO_ICON",
  INFO = "INFO",
}

export type NoticeVariant = "accent" | "filled" | "topBar";

export type AccentNoticeType = "info" | "pending" | "warning";

type FilledConfig = {
  iconComponent: typeof InformationCircleIcon | typeof WarningErrorIcon | null;
  iconColor: string;
  bgColor: string;
};

export const filledTypeConfig: Record<NoticeType, FilledConfig> = {
  [NoticeType.WARNING]: {
    iconComponent: WarningErrorIcon,
    iconColor: "text-text/warning",
    bgColor: "bg-text/warning/10",
  },
  [NoticeType.ERROR]: {
    iconComponent: WarningErrorIcon,
    iconColor: "text-text/negative",
    bgColor: "bg-text/negative/10",
  },
  [NoticeType.SUCCESS]: {
    iconComponent: CheckCircleIcon,
    iconColor: "text-text/positive",
    bgColor: "bg-text/positive/10",
  },
  [NoticeType.PENDING]: {
    iconComponent: InformationCircleIcon,
    iconColor: "text-text/pending",
    bgColor: "bg-text/pending/10",
  },
  [NoticeType.BRAND]: {
    iconComponent: InformationCircleIcon,
    iconColor: "text-text/interactive",
    bgColor: "bg-text/interactive/10",
  },
  [NoticeType.DEFAULT]: {
    iconComponent: InformationCircleIcon,
    iconColor: "text-text/secondary",
    bgColor: "bg-background/secondary/30",
  },
  [NoticeType.INFO]: {
    iconComponent: null,
    iconColor: "",
    bgColor: "bg-background/secondary/30",
  },
  [NoticeType.BRAND_NO_ICON]: {
    iconComponent: null,
    iconColor: "",
    bgColor: "bg-text/interactive/10",
  },
  [NoticeType.SECONDARY_NO_ICON]: {
    iconComponent: null,
    iconColor: "",
    bgColor: "bg-background/secondary",
  },
};

type TopBarConfig = {
  iconComponent: typeof InformationCircleIcon | typeof WarningErrorIcon;
  iconColor: string;
  bgColor: string;
};

export const topBarTypeConfig: Record<NoticeType, TopBarConfig> = {
  [NoticeType.WARNING]: {
    iconComponent: WarningErrorIcon,
    iconColor: "text-text/warning",
    bgColor: "bg-text/warning/10",
  },
  [NoticeType.ERROR]: {
    iconComponent: WarningErrorIcon,
    iconColor: "text-text/negative",
    bgColor: "bg-text/negative/10",
  },
  [NoticeType.SUCCESS]: {
    iconComponent: InformationCircleIcon,
    iconColor: "text-text/positive",
    bgColor: "bg-text/positive/10",
  },
  [NoticeType.PENDING]: {
    iconComponent: InformationCircleIcon,
    iconColor: "text-text/pending",
    bgColor: "bg-text/pending/10",
  },
  [NoticeType.BRAND]: {
    iconComponent: InformationCircleIcon,
    iconColor: "text-text/interactive",
    bgColor: "bg-text/interactive/10",
  },
  [NoticeType.DEFAULT]: {
    iconComponent: InformationCircleIcon,
    iconColor: "text-text/secondary",
    bgColor: "bg-background/secondary/30",
  },
  [NoticeType.INFO]: {
    iconComponent: InformationCircleIcon,
    iconColor: "text-text/secondary",
    bgColor: "bg-background/secondary/30",
  },
  [NoticeType.BRAND_NO_ICON]: {
    iconComponent: InformationCircleIcon,
    iconColor: "text-text/interactive",
    bgColor: "bg-text/interactive/10",
  },
  [NoticeType.SECONDARY_NO_ICON]: {
    iconComponent: InformationCircleIcon,
    iconColor: "text-text/secondary",
    bgColor: "bg-background/secondary",
  },
};

type AccentConfig = {
  borderColor: string;
  iconColor: string;
};

export const accentTypeConfig: Record<AccentNoticeType, AccentConfig> = {
  info: {
    borderColor: "border-text/positive",
    iconColor: "text-text/positive",
  },
  pending: {
    borderColor: "border-text/pending",
    iconColor: "text-text/pending",
  },
  warning: {
    borderColor: "border-text/warning",
    iconColor: "text-text/warning",
  },
};
